import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  IGetHouseOfferHistoryByHouseIdRequest,
  IMappers,
} from '../../../../repositories/valuation-offer-history/v1/get-house-offer-history-by-house-id';
import { IOffersHistoryListingData } from '../../../../types/offerHistory';
import { prepareOffersHistory } from '../../mappers';
import { EDealType } from '../../../../types/dealType';

export const createOffersHistoryListingMapper = (
  parameters: IGetHouseOfferHistoryByHouseIdRequest,
): IMappers<TMappedResponse200, TMappedResponse400> => ({
  200: response => prepareOffersHistory(response, parameters.dealType as EDealType),
  400: ({ message }) => {
    return new HttpBadStatusCodeError({
      domain: 'fetchOffersHistoryListing.ts',
      statusCode: 400,
      message: message || /* istanbul ignore next */ '',
      details: { ...parameters },
    });
  },
});

export type TMappedResponse200 = IOffersHistoryListingData;
export type TMappedResponse400 = HttpBadStatusCodeError;

export type TMappedResponse = TMappedResponse200 | TMappedResponse400;
